<template>
  <div id="wrap" :class="this.$route.path === '/' ? 'main' : ''">
    <GcrmHeader ref="gcrmHeader"></GcrmHeader>
    <div id="container">
      <router-view></router-view>
    </div>
    <GcrmFooter></GcrmFooter>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import TermPopup from '@/components/common/popup/TermPopup';
import GcrmHeader from '@/components/view/admin/main/GcrmHeader';
import GcrmFooter from '@/components/view/admin/main/GcrmFooter';

export default {
  name: 'Main',
  components: {
    GcrmHeader,
    GcrmFooter,
  },
  data() {
    return {
      isFoldSideMenu: false,
      isHideSideMenu: false,
      isRouterAlive: true,
    };
  },
  computed: {
    ...mapGetters({
      locale: 'getLocale',
    }),
  },
  methods: {
    ...mapActions(['getMenus']),
    displaySideMenu(flag) {
      this.isHideSideMenu = flag;
    },
    routerReload() {
      this.isRouterAlive = false;
      setTimeout(() => {
        this.isRouterAlive = true;
      });
    },
    showTermPopup(termsTypeCode, event) {
      SDLUtil.showLoadingBar(true);
      const title = event.currentTarget.textContent;
      axios
        .get(`${SDLUtil.API_URL}/privacypolicy/terms/${termsTypeCode}/valid?langType=${this.locale}`)
        .then(({ data }) => {
          SDLUtil.show(
            TermPopup,
            {
              title,
              term: data,
            },
            {
              width: 1000,
              height: 850,
            },
          );
          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
    },
    changeGlobalCountry() {
      this.$refs.gcrmHeader.getMyGlobal();
    },
  },
  watch: {
    $route() {
      this.isHideSideMenu = this.$route.meta.menuId === undefined;
    },
  },
  created() {
    // document.querySelector('body').classList.remove('ui--login-wrap', 'sdl-wrap');
    // Hide side menu area without menuId
    this.isHideSideMenu = this.$route.meta.menuId === undefined;
  },
  beforeCreate() {
    const redirect = this.$router.history.current.query.redirect || '';
    if (redirect) {
      this.$router.replace(redirect);
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
  },
  updated() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip();
  },
};
</script>

<style lang="scss">
  @import 'static/css/css.scss';
</style>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainPage.vue